"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
require("moment/locale/fr");
require("moment/locale/de");
require("moment/locale/nl");
require("moment/locale/it");
require("moment/locale/pt");
require("moment/locale/nb");
var DateUtils = /** @class */ (function () {
    function DateUtils() {
    }
    DateUtils.addDays = function (days, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).add(days, 'days').toDate();
    };
    DateUtils.removeDays = function (days, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).subtract(days, 'days').toDate();
    };
    DateUtils.addMonths = function (months, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).add(months, 'months').toDate();
    };
    DateUtils.removeMonths = function (months, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).subtract(months, 'months').toDate();
    };
    DateUtils.addYears = function (years, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).add(years, 'years').toDate();
    };
    DateUtils.removeYears = function (years, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).subtract(years, 'years').toDate();
    };
    DateUtils.addHours = function (hours, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).add(hours, 'hours').toDate();
    };
    DateUtils.removeHours = function (hours, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).subtract(hours, 'hours').toDate();
    };
    DateUtils.addMinutes = function (minutes, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).add(minutes, 'minutes').toDate();
    };
    DateUtils.removeMinutes = function (minutes, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).subtract(minutes, 'minutes').toDate();
    };
    DateUtils.addSeconds = function (seconds, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).add(seconds, 'seconds').toDate();
    };
    DateUtils.removeSeconds = function (seconds, from) {
        if (from === void 0) { from = new Date(); }
        return (0, moment_1.default)(from).subtract(seconds, 'seconds').toDate();
    };
    DateUtils.diff = function (from, to, granularity, precise) {
        return (0, moment_1.default)(from).diff((0, moment_1.default)(to), granularity, precise);
    };
    DateUtils.format = function (date, locale) {
        return date.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' });
    };
    DateUtils.momentFormat = function (date, format) {
        if (format === void 0) { format = moment_1.default.defaultFormat; }
        return (0, moment_1.default)(date).format(format);
    };
    DateUtils.formatTime = function (date) {
        return (0, moment_1.default)(date).format('HH:mm');
    };
    DateUtils.isSameDate = function (from, to, granularity) {
        if (granularity === 'day') {
            return (0, moment_1.default)(from).isSame((0, moment_1.default)(to), 'day');
        }
        if (granularity === 'month') {
            return (0, moment_1.default)(from).isSame((0, moment_1.default)(to), 'month');
        }
        if (granularity === 'year') {
            return (0, moment_1.default)(from).isSame((0, moment_1.default)(to), 'year');
        }
        return DateUtils.isSameDate(from, to, 'day') &&
            DateUtils.isSameDate(from, to, 'month') &&
            DateUtils.isSameDate(from, to, 'year');
    };
    DateUtils.isBefore = function (from, to, granularity) {
        return (0, moment_1.default)(from).isBefore(to, granularity);
    };
    DateUtils.isAfter = function (from, to, granularity) {
        return (0, moment_1.default)(from).isAfter(to, granularity);
    };
    DateUtils.allDay = function () {
        return [
            {
                day_id: 1,
                name: 'monday'
            },
            {
                day_id: 2,
                name: 'tuesday'
            },
            {
                day_id: 3,
                name: 'wednesday'
            },
            {
                day_id: 4,
                name: 'thursday'
            },
            {
                day_id: 5,
                name: 'friday'
            },
            {
                day_id: 6,
                name: 'saturday'
            },
            {
                day_id: 7,
                name: 'sunday'
            }
        ];
    };
    DateUtils.timeIsBetween = function (time, range) {
        if (!range.start || !range.end) {
            return false;
        }
        var lookUpTime = Number(time.replace(':', ''));
        var startTime = Number(range.start.replace(':', ''));
        var endTime = Number(range.end.replace(':', ''));
        return lookUpTime >= startTime && lookUpTime <= endTime;
    };
    DateUtils.getDayIdLikeMomentJs = function (date) {
        return (0, moment_1.default)(date).isoWeekday();
    };
    DateUtils.generateTimesBetween = function (from, to, interval) {
        if (interval === void 0) { interval = 15; }
        var amountOfSlot = (Math.floor(Math.abs(Number("".concat(from.getHours(), ".").concat(from.getMinutes())) - Number("".concat(to.getHours(), ".").concat(to.getMinutes()))) * 100) / 100) * (60 / interval);
        var dateTmp = new Date(from);
        var slots = [];
        for (var i = 0; i <= amountOfSlot; i++) {
            var updatedDate = DateUtils.addMinutes((i * interval), dateTmp);
            slots.push(DateUtils.formatTime(updatedDate));
        }
        return slots;
    };
    DateUtils.calendarSentence = function (from, to) {
        return (0, moment_1.default)(to).calendar(from);
    };
    DateUtils.setLocale = function (locale) {
        moment_1.default.locale(locale);
    };
    return DateUtils;
}());
exports.default = DateUtils;
